import { render, staticRenderFns } from "./NewsTabOverview.vue?vue&type=template&id=2dc5621d&"
import script from "./NewsTabOverview.vue?vue&type=script&lang=js&"
export * from "./NewsTabOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports